import { render, staticRenderFns } from "./ProductAutoCompleteVerified.vue?vue&type=template&id=7a5870aa&"
import script from "./ProductAutoCompleteVerified.vue?vue&type=script&lang=js&"
export * from "./ProductAutoCompleteVerified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports